import React, { useCallback } from 'react'

const Modal = ({ children, toggle }) => {
  const handleBackdropClick = useCallback((event) => {
    if (event.target === event.currentTarget) {
      toggle()
    }
  }, [toggle])

  return (

    <div className='fixed top-0 left-0 right-0 bottom-0 z-40 flex items-center justify-center bg-gray-800 bg-opacity-50' onClick={handleBackdropClick}>
      <div className='bg-white rounded-lg p-8 z-50 font-sans antialiased text-base font-normal md:w-1/2 flex flex-col text-center'>
        {children}
      </div>
    </div>
  )
}

export default Modal
